import {
    HYBRID_ACCOUNT,
    HYBRID_EXTERNAL,
    MY_STOKKE_ADDRESSES_PAGE_ID,
    MY_STOKKE_DASHBOARD_PAGE_ID,
    MY_STOKKE_ORDERS_PAGE_ID,
    MY_STOKKE_PERSONAL_INFORMATION_PAGE_ID,
    MY_STOKKE_WARRANTY_PAGE_ID,
    MY_STOKKE_WISHLIST_PAGE_ID
} from '../../constants'
import {
    BasketIcon,
    AccountIcon,
    StorefinderIcon,
    WarrantyIcon,
    HeartIcon
} from '../../components/icons'
import {defineMessage} from 'react-intl'
import loadable from '@loadable/component'

const MyStokkeDashboard = loadable(() => import('./subpages/dashboard'))
const MyStokkePersonalData = loadable(() => import('./subpages/personal-data'))
const MyStokkeAddresses = loadable(() => import('./subpages/addresses'))
const MyStokkeOrders = loadable(() => import('./subpages/orders'))
const MyStokkeOrderDetails = loadable(() => import('./subpages/order-details'))
const MyStokkeWishlist = loadable(() => import('./subpages/wishlist'))

export default [
    {
        configId: MY_STOKKE_DASHBOARD_PAGE_ID,
        component: MyStokkeDashboard,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/',
        exact: true,
        icon: AccountIcon,
        label: defineMessage({id: 'mystokke.dashboard.headline', defaultMessage: 'My Stokke®'})
    },
    {
        configId: MY_STOKKE_ORDERS_PAGE_ID,
        component: MyStokkeOrders,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/orders',
        exact: true,
        icon: BasketIcon
    },
    {
        component: MyStokkeOrderDetails,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/orders/:orderId',
        exact: true
    },
    {
        configId: MY_STOKKE_WARRANTY_PAGE_ID,
        hybridPageType: HYBRID_EXTERNAL,
        icon: WarrantyIcon
    },
    {
        configId: MY_STOKKE_PERSONAL_INFORMATION_PAGE_ID,
        component: MyStokkePersonalData,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/personal-information',
        exact: true
    },
    {
        configId: MY_STOKKE_ADDRESSES_PAGE_ID,
        component: MyStokkeAddresses,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/addresses',
        exact: true,
        icon: StorefinderIcon
    },
    {
        configId: MY_STOKKE_WISHLIST_PAGE_ID,
        component: MyStokkeWishlist,
        hybridPageType: HYBRID_ACCOUNT,
        path: '/wishlist',
        exact: true,
        allowGuest: true,
        icon: HeartIcon
    }
]
